/* Texhoma Theme — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/<[^>]*>/g, '');
  }

  function trapFocus(container) {
    var focusable = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  var openLayers = [];
  function openLayer(el, focusTarget) {
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    openLayers.push(el);
    var target = focusTarget || $('input, button, a', el);
    if (target) setTimeout(function () { target.focus(); }, 60);
    trapFocus(el);
  }
  function closeLayer(el) {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openLayers = openLayers.filter(function (l) { return l !== el; });
    if (!openLayers.length) document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLayers.length) closeLayer(openLayers[openLayers.length - 1]);
  });

  /* ---------- Announcement marquee (mobile) ---------- */
  function initAnnouncement() {
    var track = $('.announcement-bar__track');
    if (!track) return;
    function check() {
      if (window.innerWidth < 750 && track.scrollWidth > track.clientWidth && !track.dataset.cloned) {
        track.dataset.cloned = 'true';
        track.innerHTML += track.innerHTML;
        track.classList.add('is-marquee');
      }
    }
    check();
    window.addEventListener('resize', check);
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = $('#MobileMenu');
    if (!menu) return;
    $$('[data-open-mobile-menu]').forEach(function (btn) {
      btn.addEventListener('click', function () { openLayer(menu); });
    });
    $$('[data-close-mobile-menu]', menu).forEach(function (el) {
      el.addEventListener('click', function () { closeLayer(menu); });
    });
  }

  /* ---------- Search modal + predictive search ---------- */
  function initSearch() {
    var modal = $('#SearchModal');
    if (!modal) return;
    $$('[data-open-search]').forEach(function (btn) {
      btn.addEventListener('click', function () { openLayer(modal, $('input[type="search"]', modal)); });
    });
    $$('[data-close-search]', modal).forEach(function (el) {
      el.addEventListener('click', function () { closeLayer(modal); });
    });

    var input = $('input[type="search"]', modal);
    var results = $('#PredictiveResults');
    if (!input || !results || !window.routes.predictive_search_url) return;
    var timer = null;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(window.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#PredictiveSearchResults');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 250);
    });
  }

  /* ---------- Quote modal ---------- */
  function initQuoteModal() {
    var modal = $('#QuoteModal');
    if (!modal) return;
    var contextBox = $('[data-quote-context]', modal);
    var contextTitle = $('[data-quote-context-title]', modal);
    var productField = $('[data-quote-product-field]', modal);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-open-quote]');
      if (!btn) return;
      e.preventDefault();
      var title = btn.getAttribute('data-product-title') || '';
      var variant = btn.getAttribute('data-product-variant') || '';
      var url = btn.getAttribute('data-product-url') || '';
      // On product pages, read the live variant selection if present
      var form = btn.closest('[data-product-form-wrapper]');
      if (form) {
        var liveVariant = form.getAttribute('data-current-variant-title');
        if (liveVariant && liveVariant !== 'Default Title') variant = liveVariant;
      }
      if (title && contextBox && contextTitle && productField) {
        var full = title + (variant && variant !== 'Default Title' ? ' — ' + variant : '');
        contextTitle.textContent = full;
        productField.value = full + (url ? ' (' + (url.indexOf('http') === 0 ? url : window.location.origin + url) + ')' : '');
        contextBox.hidden = false;
      } else if (contextBox && productField) {
        contextBox.hidden = true;
        productField.value = '';
      }
      openLayer(modal, $('input[name="contact[name]"]', modal));
    });
    $$('[data-close-quote]', modal).forEach(function (el) {
      el.addEventListener('click', function () { closeLayer(modal); });
    });
    // Re-open modal to show success/error feedback after the page reloads from a
    // modal submission — but not when a page-level contact/quote form exists,
    // since that form shows its own status inline.
    var pageLevelForm = $('#ContactPageForm') || $('#QuotePageForm');
    if (!pageLevelForm && $('[data-quote-posted]', modal)) {
      openLayer(modal);
    }
  }

  /* ---------- Cart ---------- */
  function updateCartCounts(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
  }

  function refreshCartDrawer(open) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawerContent');
        var current = $('#CartDrawerContent');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var countEl = doc.querySelector('[data-drawer-cart-count]');
        if (countEl) updateCartCounts(parseInt(countEl.getAttribute('data-drawer-cart-count'), 10) || 0);
        bindCartDrawerEvents();
        if (open) {
          var drawer = $('#CartDrawer');
          if (drawer && !drawer.classList.contains('is-open')) openLayer(drawer);
        }
      });
  }

  function bindCartDrawerEvents() {
    var drawer = $('#CartDrawer');
    if (!drawer) return;
    $$('[data-close-cart]', drawer).forEach(function (el) {
      el.onclick = function () { closeLayer(drawer); };
    });
    $$('[data-line-qty]', drawer).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (btn) {
        btn.onclick = function () {
          var delta = btn.getAttribute('data-qty-change') === 'plus' ? 1 : -1;
          var qty = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
          changeLine(wrap.getAttribute('data-line-key'), qty);
        };
      });
    });
    $$('[data-remove-line]', drawer).forEach(function (btn) {
      btn.onclick = function () { changeLine(btn.getAttribute('data-remove-line'), 0); };
    });
  }

  function changeLine(key, qty) {
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCartDrawer(false); });
  }

  function initCartDrawer() {
    var drawer = $('#CartDrawer');
    if (!drawer) return;
    $$('[data-open-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (drawer.getAttribute('data-cart-type') !== 'drawer') return; // fall through to /cart link
        e.preventDefault();
        refreshCartDrawer(false).then(function () { openLayer(drawer); });
      });
    });
    bindCartDrawerEvents();
  }

  function initAddToCart() {
    $$('form[data-ajax-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[type="submit"]', form);
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
        var fd = new FormData(form);
        fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: fd })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (data) { throw data; });
            return r.json();
          })
          .then(function () {
            var drawer = $('#CartDrawer');
            if (drawer && drawer.getAttribute('data-cart-type') === 'drawer') {
              return refreshCartDrawer(true);
            }
            window.location.href = window.routes.cart_url;
          })
          .catch(function (err) {
            var msg = (err && err.description) || 'Could not add to cart. Please try again.';
            var status = $('[data-form-status]', form);
            if (status) { status.textContent = msg; status.hidden = false; }
            else alert(msg);
          })
          .finally(function () {
            if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
          });
      });
    });
  }

  /* ---------- Cart page quantity + remove ---------- */
  function initCartPage() {
    var cartForm = $('#CartPageForm');
    if (!cartForm) return;
    $$('[data-line-qty]', cartForm).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = btn.getAttribute('data-qty-change') === 'plus' ? 1 : -1;
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
          input.dispatchEvent(new Event('change'));
        });
      });
      input.addEventListener('change', function () {
        fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: wrap.getAttribute('data-line-key'), quantity: parseInt(input.value, 10) || 0 })
        }).then(function () { window.location.reload(); });
      });
    });
  }

  /* ---------- Quantity steppers (product page) ---------- */
  function initQuantity() {
    $$('[data-quantity]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = btn.getAttribute('data-qty-change') === 'plus' ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product form: variants, gallery ---------- */
  function initProductForms() {
    $$('[data-product-form-wrapper]').forEach(function (wrapper) {
      var jsonEl = $('[data-variants-json]', wrapper);
      if (!jsonEl) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
      var selects = $$('[data-option-select]', wrapper);
      var idInput = $('input[name="id"]', wrapper);
      var priceEl = $('[data-product-price]', wrapper);
      var stockEl = $('[data-stock-badge]', wrapper);
      var skuEl = $('[data-product-sku]', wrapper);
      var addBtn = $('[data-add-to-cart]', wrapper);

      function currentVariant() {
        var opts = selects.map(function (s) { return s.value; });
        return variants.find(function (v) {
          return opts.every(function (val, i) { return v['option' + (i + 1)] === val; });
        });
      }

      function render() {
        var v = currentVariant();
        if (!v) {
          if (addBtn) { addBtn.setAttribute('disabled', ''); $('.btn-text', addBtn).textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        wrapper.setAttribute('data-current-variant-title', v.title);
        if (priceEl) {
          var html = '';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html = '<span class="price__sale">' + formatMoney(v.price) + '</span>' +
                   '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' +
                   '<span class="product-info__save">Save ' + formatMoney(v.compare_at_price - v.price) + '</span>';
          } else {
            html = '<span>' + formatMoney(v.price) + '</span>';
          }
          priceEl.innerHTML = html;
        }
        if (skuEl) skuEl.textContent = v.sku ? 'SKU: ' + v.sku : '';
        if (stockEl) {
          stockEl.classList.toggle('stock-badge--out', !v.available);
          stockEl.textContent = v.available ? 'In stock' : 'Sold out';
        }
        if (addBtn) {
          if (v.available) { addBtn.removeAttribute('disabled'); $('.btn-text', addBtn).textContent = addBtn.getAttribute('data-label-add') || 'Add to cart'; }
          else { addBtn.setAttribute('disabled', ''); $('.btn-text', addBtn).textContent = 'Sold out'; }
        }
        if (v.featured_image && v.featured_image.position) {
          var scope = wrapper.closest('.product') || document;
          var thumb = $('[data-image-position="' + v.featured_image.position + '"]', scope);
          if (thumb) thumb.click();
        }
        if (window.history.replaceState && selects.length) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', render); });
      if (selects.length) render();
    });

    // Gallery
    $$('[data-product-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main] img', gallery);
      $$('[data-media-index]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          var src = thumb.getAttribute('data-full-src');
          if (src) { main.src = src; main.removeAttribute('srcset'); }
          main.alt = ($('img', thumb) && $('img', thumb).alt) || main.alt;
          $$('[data-media-index]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initCollectionSort() {
    var sort = $('#SortBy');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Sticky header ---------- */
  function initStickyHeader() {
    var header = $('.header-wrapper[data-sticky="true"]');
    if (!header) return;
    header.classList.add('is-sticky');
  }

  /* ---------- Desktop dropdown: close on outside click ---------- */
  function initDropdowns() {
    document.addEventListener('click', function (e) {
      $$('.header__menu details[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMobileMenu();
    initSearch();
    initQuoteModal();
    initCartDrawer();
    initAddToCart();
    initCartPage();
    initQuantity();
    initProductForms();
    initCollectionSort();
    initStickyHeader();
    initDropdowns();
    initReveal();
  });
})();
